import { Box } from "@mui/material";
import { FC, useState } from "react";
import { InputTextProps } from "./InputText";
import { DayPickerProps } from "react-day-picker";
import TextField from "./TextField";
import { Controller } from "react-hook-form";
import Calendar from "./Calendar";
import { format } from "date-fns";

type InputCalenderProps = {
  calendarProps?: DayPickerProps;
  defaultQuickDays?: number | null;
  mode?: "single" | "range";
  enableQuickSelect?: boolean;
  disableFutureDates?: boolean;
} & InputTextProps;

const InputCalender: FC<InputCalenderProps> = ({
  calendarProps,
  defaultQuickDays,
  control,
  name,
  rules,
  isError,
  mode = "range",
  enableQuickSelect,
  disableFutureDates,
  ...inputProps
}) => {
  const [openCalendar, setOpenCalendar] = useState(false);

  const formatDateValue = (value: any, isSingle: boolean) => {
    if (isSingle) {
      return value ? format(new Date(value), "dd/MM/yyyy") : "";
    }
    return value?.from && value?.to
      ? `${format(new Date(value.from), "dd/MM/yyyy")} - ${format(
          new Date(value.to),
          "dd/MM/yyyy"
        )}`
      : "";
  };

  return (
    <Controller
      control={control}
      rules={rules}
      name={name}
      render={({ field, fieldState }) => {
        const fieldValue = field?.value;
        const errorMessage = fieldState?.error?.message;

        const errorEnabled = !!errorMessage || isError;

        const val = formatDateValue(fieldValue, mode === "single");

        return (
          <Box position="relative" onClick={() => setOpenCalendar(true)}>
            <TextField
              isLabelDefaultBehaviour
              value={val}
              error={errorEnabled}
              color={errorEnabled ? "error" : "primary"}
              errorMessage={errorMessage}
              slotProps={{
                input: {
                  readOnly: true,
                },
              }}
              {...inputProps}
            />

            {openCalendar && (
              <Calendar
                mode={mode}
                selected={fieldValue}
                onChange={(val: any) => {
                  field.onChange(val);
                }}
                setShowCalendar={setOpenCalendar}
                containerProps={{
                  position: "absolute",
                  top: 56,
                  left: 0,
                  right: 0,
                  bgcolor: "custom.background.primary",
                  zIndex: 1300,
                }}
                defaultQuickDays={defaultQuickDays}
                enableQuickSelect={enableQuickSelect}
                disableFutureDates={disableFutureDates}
              />
            )}
          </Box>
        );
      }}
    />
  );
};

export default InputCalender;
